/**
 * 匿名コンサルホットライン LP 共通文言
 */
export const hotlineLpText = {
    /**
     * ボタンの文言
     */
    action: {
        consultation: () => '早速相談する',
        login: () => 'ログイン',
        myPage: () => 'マイページ',
        registration: () => '新規登録',
    },
};
